import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin, Alert } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { isRedirectLoop } from '../utils/authRedirectGuard';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  if (process.env.NODE_ENV === 'development') {
    console.log('[PRIVATE_ROUTE] render', { loading, isAuthenticated, adminOnly });
  }

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#f9fafb',
          color: '#111827',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    if (typeof window !== 'undefined') {
      if (isRedirectLoop()) {
        return (
          <div style={{ padding: 24, maxWidth: 560, margin: '40px auto' }}>
            <Alert
              type="error"
              showIcon
              message="Обнаружен цикл перенаправлений"
              description="Слишком частые переходы между страницей входа и приложением. Обновите страницу (F5) или откройте сайт в новой вкладке. Если проблема сохраняется, очистите cookie для test.pikinlab.ru и auth.pikinlab.ru и войдите снова."
            />
          </div>
        );
      }
    }
    return null;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
